<svelte:options
  customElement={{
    tag: 'fav-column-fetch',
    shadow: "none",
    props: {
      category: { type: 'String' },
      limitnumber: { type: 'Number' },
      customarray: { type: 'String' }
    }
  }}
/>

<script>
  import { onMount } from 'svelte';
  import { api } from '@util/Fetch';
  let TrimLength = 42

  let { category = '', limitnumber = 4, customarray = '' } = $props();

  let posts = $state([]);
  // let filterPosts = $state([]);
  let loading = $state(true);
  let error = $state(null);

  const custom = $derived.by(() => {
    if (customarray) {
      try {
        const targetList = JSON.parse(customarray);
        const targetTitles = targetList.map(item => item.title);
        // jsonデータの中から、customarrayに含まれるタイトルを持つものを抽出
        return targetTitles.map(title =>
          posts.find(post => post.title === title)//customarrayの順番を維持
        ).filter(Boolean); // 見つからなかった要素を除外
      } catch (e) {
        console.error('JSON parse error in customarray:', e);
        return [];
      }
    }

    // categoryが空なら全件、入っていればフィルタ
    const filtered = category ? posts.filter((i) => i.category === category) : posts;

    return filtered.slice(0, limitnumber);
  });

  async function fetchPosts() {
    loading = true;
    try {
      const data = await api.get('/assets_default/data/column.json');
      // データを 'date' の値で最新順（降順）に並べ替える
      posts = data.sort((a, b) => new Date(b.date) - new Date(a.date));
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }

  function TextTrimming(text) {
    const textLength = text.length
    return textLength > TrimLength ? `${text.slice(0,TrimLength)}…` : text
  }
  onMount(() => {
    fetchPosts();
  });
</script>

{#if loading}
  <p>Loading...</p>
{:else if error}
  <p>Error: {error.message}</p>
{:else}
  {#each custom as custom,i }
    <a href="{custom.link}" class="p-column-link-card">
      <picture class="p-column-image:inner margin:bottom:sm p-column-link-card-image picture-border">
        <img src="{custom.thumbnail}" alt="">
      </picture>
      <p class="p-column-label">{custom.label}</p>
      <p class="p-column-text margin:bottom:sm"><strong>{TextTrimming(custom.title)}</strong></p>

      {#if custom.hashtag}
        <ul class="p-column-hashtag-list">
          {#each custom.hashtag as tag}
            <li class="hashtag">#{tag}</li>
          {/each}
        </ul>
      {/if}
    </a>
  {/each}
{/if}


<style>

  .picture-border {
    border: 1px solid #000;
    border-radius: 12px;
    overflow: hidden;
  }

  .column-text {
    margin-bottom: 20px;
  }

</style>
